import React, { useEffect } from "react";
import { useStateContext } from "../../context/ContextProvider";
import { useLocation } from "react-router-dom";

const LanguageWrapper = ({
    children,
    language
}) => {
    const {
        changeLanguage,
        i18n
    } = useStateContext();
    const location = useLocation();

    useEffect(() => {
        const routeLanguage = language || i18n.language;
        if (routeLanguage && routeLanguage !== i18n.language) {
            changeLanguage(routeLanguage);
        }
    }, [language, i18n.language, changeLanguage, location]);

    return (
        <>
            {children}
        </>
    )
}

export default LanguageWrapper;